"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginAPIUrl = void 0;
var getLoginAPIUrl = function getLoginAPIUrl() {
  var topLevelDomain = window.location.hostname;
  if (topLevelDomain.includes("localhost")) {
    return window.location.origin;
  }
  var regex = /((quintoandar.|forno.|staging.|full.)*?\w+.\w+)$/g;
  return "https://login.".concat(topLevelDomain.match(regex).toString());
};
exports.getLoginAPIUrl = getLoginAPIUrl;
